import { AbstractControl } from '@angular/forms';

export class GlobalValidators {

    static readonly PATTERN_EMAIL =
        `^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)`
        + `|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$`;

    static email(control: AbstractControl): any {

        let matches = new RegExp(GlobalValidators.PATTERN_EMAIL).test(control.value);
        if (!matches) {
            return { 'incorrectMailFormat': true, msg: 'Invalid email.' };
        }

        return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/components/common/validators.ts